import { translate as t } from '@thoughtspot/i18n';
import { ErrorCode } from '@thoughtspot/radiant-react/widgets/alert';
import _ from 'lodash';
import { ChartType } from '../../types/prism';
import { customChartErrorTemplate, ErrorTypes, tsHostedCustomChartErrorMessagesMap, } from './chart-error.helper';
import { getTranslatedStringsForMessageCode } from './error-strings-mapping';
const DEFAULT_ERROR_MESSAGES = {
    TITLE: 'tsHostedCustomChartErrorMessages.UNKNOWN_ERROR.title',
    DESCRIPTION: 'tsHostedCustomChartErrorMessages.UNKNOWN_ERROR.description',
};
export class CustomChartError extends Error {
    constructor(errorType, message, ErrorMsgCode) {
        super(message);
        this.errorType = errorType;
        this.ErrorMsgCode = ErrorMsgCode;
    }
}
export const convertErrorObjectToChartErrorObject = (err) => {
    const { summary, detail, title } = getTranslatedStringsForMessageCode(err);
    const defaultTitle = t(DEFAULT_ERROR_MESSAGES.TITLE);
    const defaultDescription = t(DEFAULT_ERROR_MESSAGES.DESCRIPTION);
    return {
        errorTitle: title || defaultTitle,
        errorDescription: summary || defaultDescription,
        errorDetail: detail || summary || defaultDescription,
        errorCode: ErrorCode.LOCAL_VISUALIZATION,
        shouldShowErrorImage: true,
        ErrorMsgCode: err.code,
        shouldShowErrorDetail: true,
        shouldShowErrorDescription: true,
    };
};
export const getErrorObject = (errorType, chartType, errorDescription) => {
    const coustomChartErrorTemplates = customChartErrorTemplate();
    const TsHostedCustomChartErrorTemplate = tsHostedCustomChartErrorMessagesMap();
    const errorObject = chartType === ChartType.CustomChart
        ? coustomChartErrorTemplates[errorType] ??
            coustomChartErrorTemplates[ErrorTypes.GENERIC_ERROR]
        : TsHostedCustomChartErrorTemplate[errorType] ??
            TsHostedCustomChartErrorTemplate[ErrorTypes.GENERIC_ERROR];
    if ((chartType !== ChartType.CustomChart &&
        errorType !== ErrorTypes.CHART_RENDER_ERROR) ||
        _.isEmpty(errorDescription) ||
        errorType === ErrorTypes.GENERIC_ERROR) {
        return errorObject;
    }
    return {
        ...errorObject,
        errorDescription,
    };
};
export const getErrorStringForBanner = (errDescription, ErrorMsgCode) => {
    if (ErrorMsgCode) {
        return `${errDescription} (Error Code: ${ErrorMsgCode})`;
    }
    return errDescription;
};
//# sourceMappingURL=chart-error.util.js.map